import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="page-container">
      <motion.div 
        className="hero"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <motion.h1
          initial={{ scale: 0.5 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          DANDRE
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          My best friend who's destined for greatness. A future football star, basketball talent, and an amazing person who deserves all the chocolate in the world.
        </motion.p>
      </motion.div>

      <motion.div 
        className="avatar-container"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.7 }}
      >
        <img 
          src="/avatar.png" 
          alt="Dandre's Roblox Avatar" 
          className="avatar"
          style={{ width: '200px', height: '200px', borderRadius: '50%', border: '3px solid #007bff' }}
        />
        <h3 style={{ marginTop: '1rem', color: '#ccc' }}>Dandre's Roblox Avatar</h3>
      </motion.div>

      <div className="grid">
        <motion.div 
          className="card"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.9 }}
        >
          <h2>🎮 Gaming Legend</h2>
          <p>
            Dandre is not just any gamer - he's a Roblox legend! With his username @Rex123456724, 
            he's conquered countless games and built amazing creations. His gaming skills are 
            unmatched, and he's always ready for the next adventure.
          </p>
          <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem', flexWrap: 'wrap' }}>
            <Link to="/roblox" className="btn">
              View Roblox Profile
            </Link>
            <a 
              href="https://www.roblox.com/users/1332092262/profile" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn"
              style={{ background: '#444' }}
            >
              Real Roblox Page
            </a>
          </div>
        </motion.div>

        <motion.div 
          className="card"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 1.1 }}
        >
          <h2>⚽ Sports Superstar</h2>
          <p>
            Whether it's football or basketball, Dandre dominates the field and court. 
            His dedication, skill, and natural talent make him unstoppable. 
            I know he's going to make it far in football - the world better watch out!
          </p>
          <Link to="/sports" className="btn" style={{ marginTop: '1rem' }}>
            Sports Journey
          </Link>
        </motion.div>

        <motion.div 
          className="card"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.3 }}
        >
          <h2>🍫 Chocolate Chronicles</h2>
          <p>
            From birthday surprises to tough days, chocolate has been our friendship currency. 
            Whether it's 20 bars for his birthday or 16 to brighten a difficult day, 
            every chocolate tells a story of our amazing friendship.
          </p>
          <Link to="/stories" className="btn" style={{ marginTop: '1rem' }}>
            Read Stories
          </Link>
        </motion.div>
      </div>

      <motion.div 
        className="card"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 1.5 }}
        style={{ textAlign: 'center', marginTop: '3rem' }}
      >
        <h2>Why Dandre is the Best</h2>
        <p style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
          Dandre isn't just my best friend - he's family. Through every challenge, every victory, 
          and every chocolate bar, we've built a friendship that's unbreakable. 
          He's going places, and I'm proud to be along for the ride.
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap' }}>
          <span className="btn">🏆 Future Champion</span>
          <span className="btn">🎯 Goal Achiever</span>
          <span className="btn">💪 Never Gives Up</span>
          <span className="btn">🤝 Loyal Friend</span>
        </div>
      </motion.div>
    </div>
  );
};

export default Home;